import { GridItem } from '@bnnvara/grids';
import React from 'react';

import Share from '../components/Share';
import { LikeButton } from '../components/LikeButton';
import * as S from '../components/Share/styled';

const ComposableLikeShareContainer = (props) => (
  <GridItem
    columnStartSm="1"
    columnEndSm="-1"
    columnStartMd="2"
    columnEndMd="12"
    columnStartLg="3"
    columnEndLg="11"
    html
  >
    <S.LikeShareButtonsContainer>
      <LikeButton {...props} />
      <Share {...props} />
    </S.LikeShareButtonsContainer>
  </GridItem>
);

export default ComposableLikeShareContainer;
